import { VARIABLES } from "../Constants/Constants";
import CryptoJS from "crypto-js";
import jwt_decode from "jwt-decode";
import { SecretKeys } from "../Constants/SecretKey";

const getDecrypted = (key: any = VARIABLES.userSession) => {
  let userData: any = localStorage.getItem(key);
  try {
    if (userData) {
      let temp: any = userData && CryptoJS.AES.decrypt(userData, SecretKeys.cryptoSecretKey);
      userData = JSON.parse(temp?.toString(CryptoJS.enc.Utf8))
      console.log(userData)
    }
    else if (localStorage.getItem('userDetails')) {
      let temp: any = localStorage.getItem('userDetails')
      userData = JSON.parse(temp)
    }
  } catch (e) {
    // console.log('* user session\n', userData, e);
    userData = null;
  }
  return userData;
}

const decryptFunction = (item: any) => {
  let decryptData: any = localStorage.getItem(item);
  try {
    if (decryptData) {
      let temp: any = decryptData && CryptoJS.AES.decrypt(decryptData, SecretKeys.cryptoSecretKey);
      decryptData = JSON.parse(temp?.toString(CryptoJS.enc.Utf8))
    }
  } catch (e) {
    // console.log('* user session\n', userData, e);
    decryptData = null;
  }
  return decryptData;
}

const get = (key: any = VARIABLES.userSession) => {
  let userData = localStorage.getItem(key);
  try {
    if (userData) {
      userData = jwt_decode(userData);
    }
  } catch (e) {
    // console.log('* user session\n', userData, e);
    userData = null;
  }
  return userData;
}

const set = (data: any, key: any) => {
  let tempData;
  try {
    if (typeof data === 'object') tempData = JSON.stringify(data);
    else if (typeof data === 'string') tempData = data;
    localStorage.setItem(key || VARIABLES.userSession, tempData ? tempData : "");
  } catch (e) { console.log('Session Service * setSession', e) }
}

const setKey = (keyValue: any, sessionKey: any) => {
  try {
    let session: any = get(sessionKey);
    session = { ...session, ...keyValue };
    set(session, sessionKey);
  } catch (e) { console.log('Session Service * setSession', e) }
}

const clear = (key: any) => {
  localStorage.removeItem(key);
}

const sessionService = {
  getDecryptedSession: getDecrypted,
  getSession: get,
  setSession: set,
  setKey: setKey,
  clearSession: clear,
};

export { sessionService, decryptFunction };